import { Modal, Row, Col, Form } from 'react-bootstrap'
import { useEffect, useState, useRef } from "react";
import { Dropdown, Button } from "react-bootstrap";
import Spinner from 'react-bootstrap/Spinner';
import { FormInputElement } from '../../Form/FormInputElement';
import AddressForm from '../../Form/AddressForm';
import { useApiClient } from '../../../ApiService/useApiClient';

const AddEditClientContacts = ({ show, action, setShowAddEdit, data, setdata, CustomerId, fulldata }) => {

    const api = useApiClient();

  const formDefault = {
    opened: true,
    modalTitle: "Add New Contact Address"
  }
  const [formModal, setFormModal] = useState(formDefault);
  const [error, setError] = useState(null);
  const modalForm = useRef(null);
  const [validated, setValidated] = useState(false);

  const [addressComponents, setAddressComponents] = useState({
    company_add1: '',
    company_add2: '',
    company_add3: '',
    company_add4: '',
    postcode: '',
    lat: "",
    lng: ""
  });

  const autocompleteStyles = `
    .pac-container {
      z-index: 1051 !important;
    }
  `;

  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `.pac-container { z-index: 2000 !important; }`;
    document.head.appendChild(style);

    if (action !== "add") {
      setFormModal({
        ...formModal,
        opened: show,
        action: action,
        title: data.title,
        Fname: data.name,
        company_add1: data.add1,
        company_add2: data.add2,
        company_add3: data.add3,
        company_add4: data.add4,
        postcode: data.postcode,
        EmailAddress: data.email,
        MobileNo: data.mobile,
        TelNo: data.phone,
        LiveWithClient: data.LiveWithClient,
        Relationship: data.relationship,
        Id: data.id
      });
    } else {
      setFormModal({ ...formModal, opened: show, action: action });
    }
  }, [show]);

  function closeFormModal() {
    const updateFormModal = { ...formModal, opened: false }
    setFormModal(updateFormModal);
    setShowAddEdit(false);
  }

  function handleFormSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    const form = modalForm.current;
    if (!form.checkValidity()) {
      setValidated(true);
      return;
    }

    const title = form.querySelector('#title').value;
    const name = form.querySelector('#name').value;
    const Relationship = form.querySelector('#Relationship').value;
    const EmailAddress = form.querySelector('#EmailAddress').value;
    const MobileNo = form.querySelector('#MobileNo').value;
    const TelNo = form.querySelector('#TelNo').value;
    const company_add1 = form.querySelector('#company_add1').value;
    const company_add2 = form.querySelector('#company_add2').value;
    const company_add3 = form.querySelector('#company_add3').value;
    const company_add4 = form.querySelector('#company_add4').value;
    const postcode = form.querySelector('#postcode').value;
    const LiveWithClient = form.querySelector('#LiveWithClient').value;

    if (!name || !company_add1 || !postcode) {
      setValidated(true);
      return;
    }

    const frmFormData = new FormData();
    if (formModal.action !== "add") frmFormData.append("Id", formModal.Id);
    frmFormData.append("CustomerId", CustomerId);
    frmFormData.append("Title", title);
    frmFormData.append("Name", name);
    frmFormData.append("Relationship", Relationship);
    frmFormData.append("Email", EmailAddress);
    frmFormData.append("Mobile", MobileNo);
    frmFormData.append("Phone", TelNo);
    frmFormData.append("Add1", company_add1);
    frmFormData.append("Add2", company_add2);
    frmFormData.append("Add3", company_add3);
    frmFormData.append("Add4", company_add4);
    frmFormData.append("Postcode", postcode);
    frmFormData.append("LiveWithClient", LiveWithClient);

    let sURLSuffix = "HMCareData/customer/addcontact/";
    if (formModal.action !== "add") sURLSuffix = "HMCareData/customer/modifycontact/";

    const sURL = sURLSuffix;
  
    api.post(sURL, frmFormData)
      .then((Response) => {
        const updatedDataObj = Response.data;
        if (formModal.action !== "add") {
          const updatedData = fulldata.map(el => (el.id === updatedDataObj.id ? {
            ...el,
            title: updatedDataObj.title,
            name: updatedDataObj.name,
            add1: updatedDataObj.add1,
            add2: updatedDataObj.add2,
            add3: updatedDataObj.add3,
            add4: updatedDataObj.add4,
            postcode: updatedDataObj.postcode,
            email: updatedDataObj.email,
            mobile: updatedDataObj.mobile,
            phone: updatedDataObj.phone,
            LiveWithClient: updatedDataObj.LiveWithClient,
            relationship: updatedDataObj.relationship
          } : el));
          setdata(updatedData);
        } else {
          setdata([...data, updatedDataObj]);
        }
      }).catch(error => {
        setError(error);
        console.log({ error });
      });

    closeFormModal();
    return null;
  }

  return (
    <Modal show={formModal.opened} onHide={closeFormModal} size="lg" backdrop="static">
      <Form ref={modalForm} noValidate validated={validated} onSubmit={handleFormSubmit}>
        <Modal.Header closeButton>
          <Modal.Title className="event-title" as="h4">{formModal.modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="g-gs">
            <Col xs="2">
              <Form.Group>
                <Form.Label htmlFor="eventTitle">Title</Form.Label>
                <Form.Select id="title" defaultValue={formModal.title}>                                
                  <option value="Mr">Mr</option>
                  <option value="Mrs">Mrs</option>                                
                  <option value="Ms">Ms</option>                                                                                     
                  <option value="Ms">Dr</option>                                                                                     
                </Form.Select>
              </Form.Group>
            </Col>

            <FormInputElement type="text" id="name" ColWidth={10} maxLength={255} Label="Name" defaultValue={formModal.Fname} placeholder="Name" required={true} />
            <FormInputElement type="text" id="Relationship" ColWidth={6} maxLength={150} Label="Relationship" defaultValue={formModal.Relationship} placeholder="Relationship, Eg GP Surgery" required={true} />

            <Col xs="10">
              {formModal.action === 'add' && (
                <AddressForm
                  address={addressComponents}
                  setAddress={setAddressComponents}
                  validated={validated}
                />)}
              {formModal.action === 'edit' && (
                <Form.Group>
                  <Form.Label htmlFor="eventTitle">Address</Form.Label>
                  <div className="form-control-wrap">
                    <Form.Control id="company_add1" maxLength={150} type="text" defaultValue={formModal.company_add1} placeholder="Address Line 1" required isInvalid={validated && !formModal.company_add1} />
                    <Form.Control.Feedback type="invalid">Please enter address line 1.</Form.Control.Feedback>
                    <Form.Control id="company_add2" maxLength={150} type="text" defaultValue={formModal.company_add2} placeholder="Address Line 2" />
                    <Form.Control id="company_add3" maxLength={50} type="text" defaultValue={formModal.company_add3} placeholder="Town/city" />
                    <Form.Control id="company_add4" maxLength={50} type="text" defaultValue={formModal.company_add4} placeholder="County" />
                    <Form.Control id="postcode" maxLength={8} type="text" defaultValue={formModal.postcode} placeholder="Postcode" required isInvalid={validated && !formModal.postcode} />
                    <Form.Control.Feedback type="invalid">Please enter postcode.</Form.Control.Feedback>
                  </div>
                </Form.Group>
              )}
            </Col>

            <FormInputElement type="text" id="EmailAddress" ColWidth={6} maxLength={100} Label="Email Address" defaultValue={formModal.EmailAddress} placeholder="Email Address" required={true} />
            <FormInputElement type="text" id="MobileNo" ColWidth={6} maxLength={100} Label="Mobile Number" defaultValue={formModal.MobileNo} placeholder="Mobile Number" required={true} />
            <FormInputElement type="text" id="TelNo" ColWidth={6} maxLength={12} Label="Phone" defaultValue={formModal.TelNo} placeholder="Home Phone" />

            <Col xs="2">
              <Form.Group>
                <Form.Label htmlFor="eventTitle">Live With Client</Form.Label>
                <Form.Select id="LiveWithClient" defaultValue={formModal.LiveWithClient}>                                
                  <option value="0">No</option>    
                  <option value="1">Yes</option>                                                                                                                             
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={closeFormModal}>Discard</Button>
          {formModal.action === 'add' && <Button variant="primary" type="submit">Add Contact</Button>}
          {formModal.action === 'edit' && <Button variant="primary" type="submit">Update Contact</Button>}
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

export default AddEditClientContacts;
